import React from 'react';
import { Outlet } from 'react-router-dom';
import VendorSidebar from '../VendorSidebar';
import VendorHeader from '../VendorHeader';
import { useSidebar } from '../../../contexts/SidebarContext';
import { useAuth } from '../../../contexts/AuthContext';
import { Loader2 } from 'lucide-react';

const VendorLayout = () => {
  const { isVendorSidebarCollapsed, isVendorMobileSidebarOpen } = useSidebar();
  const { isLoading: authLoading } = useAuth();

  // Show loading while checking auth
  if (authLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <Loader2 className="w-8 h-8 animate-spin text-primary-600 mx-auto mb-4" />
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }
  
  return (
    <div className="min-h-screen bg-gray-50">
      <VendorHeader />
      <div className="flex pt-20"> {/* Add top padding to account for fixed header */}
        <VendorSidebar />
        <main className={`flex-1 transition-all duration-300 ${
          isVendorSidebarCollapsed ? 'lg:ml-16' : 'lg:ml-64'
        } ${isVendorMobileSidebarOpen ? 'lg:ml-0' : ''}`}>
          <div className="p-4 sm:p-6">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default VendorLayout;
